import classnames from 'classnames'
import React, { FC } from 'react'

import productHelper from '@src/quince-site-common/src/helpers/productHelper'

import { ProductCardTag } from '../../product-card.types'

import styles from './product-tags.module.scss'
import { ReadyToShip } from './ready-to-ship'

export const ProductTags: FC<{ applicableTags?: ProductCardTag[]; readyToShip?: boolean; className?: string }> = ({
  applicableTags = [],
  readyToShip = false,
  className,
}) => {
  return (
    <ul className={classnames(styles.tagList, className)}>
      {applicableTags.map(tag => {
        return (
          <li className={classnames(styles.tag, tag.tagType && styles[`tag__${tag.tagType}`])} key={tag.value}>
            {productHelper.getTagValueWithFirstLetterUpperCase(tag.value)}
          </li>
        )
      })}
      <ReadyToShip shouldShowReadyToShipTag={readyToShip} />
    </ul>
  )
}
